var _ = require('lodash');

module.exports = {
  toSafeArray: function (value) {
    if (value) {
      if (!_.isArray(value)) {
        return [value];
      }

      return value;
    }

    return [];
  }
};



//////////////////
// WEBPACK FOOTER
// ./src/base/util/ArrayHelper.js
// module id = 23
// module chunks = 0